module.exports = __webpack_public_path__ + "img/icon-c-d-8.b6deb525.png";